/* import React from 'react';
import CookieHandler from './components/CookieHandler';  
import UrlRedirectors from './components/UrlRedirector';
import CheckingBrowser from './components/CheckingBrowser';


function App() {
    return (
        <div>
            <CheckingBrowser />
            <UrlRedirectors />
            <CookieHandler />
        </div>
    );
}

export default App; */

import React, { useEffect, useState } from 'react';
import CookieHandler from './components/CookieHandler';  
import UrlRedirectors from './components/UrlRedirector';
import CheckingBrowser from './components/CheckingBrowser';

function App() {
    const [showRedirector, setShowRedirector] = useState(false);

    useEffect(() => {
        // Delay rendering of UrlRedirectors
        const timer = setTimeout(() => {
            setShowRedirector(true);
        }, 100); // Adjust delay as needed
        return () => clearTimeout(timer);
    }, []);

    return (
        <div>
            <CheckingBrowser />
            <CookieHandler />
            {/* {showRedirector && <UrlRedirectors />} */}
            <UrlRedirectors />
        </div>
    );
}

export default App;